import React from 'react';

const FIELDS = [
  { key: 'names', label: 'Names to include *', placeholder: 'e.g. Sarah & James, Grandma Rose' },
  { key: 'occasion', label: 'Occasion *', placeholder: 'e.g. Our wedding day, Dad\u2019s 60th birthday' },
  { key: 'genre', label: 'Preferred music genre', placeholder: 'e.g. Acoustic, Pop, Soul, Country' },
  { key: 'mood', label: 'Mood', placeholder: 'e.g. Uplifting, romantic, reflective' },
  { key: 'language', label: 'Language', placeholder: 'e.g. English' },
];

const inputClass = (error) =>
  `w-full px-4 py-3 bg-white/10 text-white placeholder-gray-500 border rounded-lg focus:outline-none transition-colors ${
    error ? 'border-red-500 focus:border-red-400' : 'border-white/20 focus:border-amber-500'
  }`;

export const SongDetailsFields = ({ value, onChange, showErrors }) => {
  const set = (key) => (e) => onChange({ ...value, [key]: e.target.value });
  const missing = (key) => showErrors && ['names', 'occasion'].includes(key) && !value[key].trim();

  return (
    <div className="vc-song-details rounded-xl border border-amber-500/30 bg-black/40 p-5 space-y-4" data-testid="song-details-box">
      <div>
        <p className="text-white font-semibold text-sm uppercase tracking-wider">Tell us about your song</p>
        <p className="text-gray-400 text-xs mt-1">These details help us write a song that feels truly yours.</p>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.key === 'language' ? 'md:col-span-2' : ''}>
            <label htmlFor={`song-${f.key}`} className="block text-sm font-medium mb-2">{f.label}</label>
            <input id={`song-${f.key}`} type="text" value={value[f.key]} onChange={set(f.key)} maxLength={f.key === 'names' ? 300 : 200}
              placeholder={f.placeholder} className={inputClass(missing(f.key))} data-testid={`song-${f.key}-input`} aria-invalid={missing(f.key)} />
            {missing(f.key) && <p className="text-xs text-red-400 mt-1">Please add this so we can personalise your song</p>}
          </div>
        ))}
      </div>
      <div>
        <label htmlFor="song-memories" className="block text-sm font-medium mb-2">Special memories</label>
        <textarea id="song-memories" rows="3" value={value.memories} onChange={set('memories')} maxLength={2000}
          placeholder="Moments, places, phrases or stories you'd love the song to capture..."
          className={`${inputClass(false)} resize-none`} data-testid="song-memories-input" />
      </div>
    </div>
  );
};

export default SongDetailsFields;
